import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Card,
  Tabs,
  Tab,
  Box,
  CardContent,
  CircularProgress,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { orderService } from "../../services/order-service";
import OrderList from "../../components/order-list";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [count, setCount] = useState();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const navigate = useNavigate();

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 15));
    setPage(0);
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await orderService.fetch(
        rowsPerPage,
        rowsPerPage * page,
        tabIndex === 0 ? "M2C" : "M2O"
      );
      setOrders(response.data);
      setCount(response.total);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [rowsPerPage, page, tabIndex]);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          sx={{
            textTransform: "none",
            backgroundColor: "#D13438",
            "&:hover": {
              backgroundColor: "#b42b2d",
            },
          }}
          onClick={() => navigate("/order-import")}
          variant="contained"
        >
          <Typography
            fontFamily={"poppins"}
            fontSize={"14px"}
            fontWeight={500}
            color="#fff"
          >
            Add/Upload
          </Typography>
        </Button>
      </div>
      <Container
        disableGutters
        maxWidth={false}
        style={{ paddingLeft: 0, paddingRight: 0 }}
        sx={{
          maxWidth: "100%",
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <Card
          elevation={0}
          sx={{
            borderRadius: 0,
            maxWidth: "100%",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            variant="fullWidth"
            textColor="primary"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#D13438",
              },
            }}
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Tab
              label="M2C"
              sx={{
                "&.Mui-selected": {
                  color: "#D13438",
                },
              }}
            />
            <Tab
              label="M2O"
              sx={{
                "&.Mui-selected": {
                  color: "#D13438",
                },
              }}
            />
          </Tabs>

          <CardContent>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 9999,
                  color: "white",
                }}
              >
                <CircularProgress color="inherit" />
              </Box>
            ) : (
              <OrderList
                data={orders}
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                type={tabIndex === 0 ? "M2C" : "M2O"}
              />
            )}
          </CardContent>
        </Card>
      </Container>
    </>
  );
};

export default Orders;
